import React, { useContext, useEffect, useRef } from "react";
import "../css/paysuccess.css";
import Header from "./Header";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = searchParams.get("state") === "success";
  const cartCleared = useRef(false);

  useEffect(() => {
    if (isSuccess && !cartCleared.current) {
      cartCleared.current = true;
      clearCart();
    }
  }, [clearCart, isSuccess]);

  return (
    <>
      <Header />
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div
              className={`payment-status-icon ${
                isSuccess ? "is-success" : "is-cancel"
              }`}
            >
              <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
            </div>
            <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
            <p>
              {isSuccess
                ? "Thank you. Your order has been received and is being reviewed."
                : "Your payment was not completed. Your cart has been kept so you can try again."}
            </p>
            <Link
              className="payment-status-action"
              to={isSuccess ? "/shop" : "/checkout"}
            >
              {isSuccess ? "Continue shopping" : "Return to checkout"}
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentStatus;
